<template>
    <v-dialog
      v-model="localDialog"
      width="50%"
      @update:modelValue="updateDialog"
      transition=""
      persistent
      :open-delay="0"
      :close-delay="0"
    >
      <base-card
      :title="isEntryMode ? 'Add LC Document Type' : 'Update LC Document Type'"
      :v-card-text-class="'pa-4'"
    >
<v-form @submit.prevent="submit" ref="LcDocumentTypeSetup">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  density="compact" 
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  v-model="name.value.value"
                  :error-messages="name.errorMessage.value"
                  clearable
                >
                  <template #label>
                    Name <span class="text-red-accent-4">*</span>
                  </template>
                </v-text-field>

                <v-select
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  v-model="trade_type.value.value"
                  :error-messages="trade_type.errorMessage.value"
                  :items="tradeTypeOptions"
                  item-title="label"
                  item-value="value"
                  clearable

                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                  <template #label>
                    Trade Type <span class="text-red-accent-4">*</span>
                  </template>
                </v-select>

                <v-text-field
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  v-model="bn_name.value.value"
                  :error-messages="bn_name.errorMessage.value"
                  clearable
                >
                  <template #label>
                    Bangla Name (Optional)
                  </template>
                </v-text-field>

                <v-textarea
                  label="Remarks (Optional)"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  v-model="remarks.value.value"
                  :error-messages="remarks.errorMessage.value"
                  clearable
                  auto-grow
                  rows="2"
                ></v-textarea>

                <v-checkbox
                  label="Active"
                  v-model="status.value.value"
                  :error-messages="status.errorMessage.value"
                  density="compact"
                  hide-details
                  color="primary"
                  true-value="1"
                  false-value="0"
                ></v-checkbox>
              </v-col>

              <input v-model="document_type_id.value.value" type="hidden" />
            </v-row>

            <v-divider></v-divider>
            <v-card-actions>
              <v-layout class="justify-end">
                <v-btn
                  class="bg-red"
                  variant="flat"
                  type="reset"
                  @click="closeDialog"
                  >Close</v-btn
                >
                <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                  {{ isEntryMode ? "Save" : "Update" }}
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-form>
        </base-card>
    </v-dialog>
  </template>

  <script>
import baseCard from '@/components/utils/baseCard.vue';
  import { ref } from "vue";
  import { useStore } from "vuex";
  import { useField, useForm } from "vee-validate";
  import * as yup from "yup";
  import { toast } from "vue3-toastify";

  export default {
  components: { baseCard },
    name: "LcDocumentTypeSetup",
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
        default: () => ({
          name: "",
          trade_type: "",
          bn_name: "",
          remarks: "",
          status: "1",
          document_type_id: null,
        }),
      },
    },
    data() {
      return {
        localDialog: this.dialog,
        isEntryMode: true,
        tradeTypeOptions: [
          { label: "Import", value: "import" },
          { label: "Export", value: "export" },
          { label: "Both", value: "both" },
        ],
      };
    },
    watch: {
      dialog(val) {
        this.localDialog = val;
      },
      localDialog(val) {
        this.$emit("update:dialog", val);
      },
      data: {
        handler(newData) {
          this.isEntryMode = !newData.id;
          this.resetForm({ errors: {}, touched: {} });
          this.name.setValue(newData.name || "", false);
          this.trade_type.setValue(newData.trade_type || "", false);
          this.bn_name.setValue(newData.bn_name || "", false);
          this.remarks.setValue(newData.remarks || "", false);
          this.status.setValue(String(newData.status) || "1", false);
          this.document_type_id.setValue(newData.id || "", false);
        },
      },
    },
    methods: {
      updateDialog(val) {
        this.$emit("update:dialog", val);
      },
      closeDialog() {
        this.$emit("update:dialog", false);
      },
    },
    setup(props, { emit }) {
      const { handleSubmit, resetForm } = useForm({
        validationSchema: yup.object({
          name: yup.string().min(1).max(255).required().trim().label("Name"),
          trade_type: yup.string().required().oneOf(["import", "export", "both"]).label("Trade Type"),
          bn_name: yup.string().max(255).nullable().trim().label("Bangla Name"),
          remarks: yup.string().max(255).nullable().trim().label("Remarks"),
        }),
      });

      const name = useField("name");
      const trade_type = useField("trade_type");
      const bn_name = useField("bn_name");
      const remarks = useField("remarks");
      const status = useField("status");
      const document_type_id = useField("document_type_id");
      const store = useStore();

      const submit = handleSubmit((values) => {
        const payload = {
          ...values,
          id: values.document_type_id || null,
        };

        store
          .dispatch("saveUpdateLcDocumentType", payload)
          .then((response) => {
            resetForm();
            emit("update:dialog", false);
            toast.success(response.data.message);
            store.dispatch("getLcDocumentTypeList");
          })
          .catch((error) => {
            toast.error(error.response?.data?.message || "Failed to save");
          });
      });

      return {
        submit,
        name,
        trade_type,
        bn_name,
        remarks,
        status,
        document_type_id,
        resetForm,
      };
    },
  };
  </script>

  <style scoped>
  .bg-brand {
    background-color: #1976d2;
    color: white;
  }
  </style>